import { IconButton } from "@mui/material";
import React from "react";
import IMessage from "../../../../interface/IMessage";
import { AppContext } from "../../../../store/genesys.context";
import SendMessageIcon from "../../../atoms/icons/sendMessageIcon.styled";

const RenderSendMessageButton = (): React.JSX.Element => {
  const {
    chatInput,
    handleSubmitMessage,
  }: {
    chatInput: IMessage;
    handleSubmitMessage: (e: { preventDefault: () => void }) => Promise<void>;
  } = React.useContext(AppContext);

  const handleDisableButton = (): "flex" | "none" =>
    chatInput.text || chatInput.content ? "flex" : "none";

  return (
    <IconButton
      aria-label="Nachricht senden"
      aria-controls="chat-message-log" // A11Y FIX
      aria-describedby="chat-input-hint chat-input-status" // A11Y FIX
      onClick={handleSubmitMessage}
      disableFocusRipple
      disableRipple
      disabled={chatInput.sending}
      aria-disabled={chatInput.sending} // A11Y FIX
      sx={{
        display: handleDisableButton(),
        justifyContent: "center",
        alignItems: "center",
        color: (theme) => theme.palette.widgetStyles.chatControls.iconColor,

        "&:hover *": {
          color: (theme) =>
            theme.palette.widgetStyles.chatControls.iconHoverColor,
        },
        // A11Y FIX: visible keyboard focus indicator (MUI removes the native
        // outline and the ripple is disabled here).
        "&:focus-visible": {
          outline: (theme) => `2px solid ${theme.palette.primary.main}`,
          outlineOffset: "2px",
        },
      }}
    >
      <SendMessageIcon />
    </IconButton>
  );
};

export default RenderSendMessageButton;
